import * as React from 'react';
import { Modal, ModalBody, ModalHeader } from 'baseui/modal';
import { ModalHeaderOverride } from '@app/react-baseweb/baseweb-custom-theme/customTheme';
import { EventFilters } from '../../types/push-api-models';

const renderFilterValues = (
  field: string,
  key: string,
  value?: string | string[],
) => {
  if (!value) return null;
  if (Array.isArray(value)) {
    return value.map((v, idx) => (
      <div key={`${field}-${key}-${idx}`}>
        "{field}" {key} "{v}"
      </div>
    ));
  }
  return (
    <div key={`${field}-${key}`}>
      "{field}" {key} "{value}"
    </div>
  );
};

const formatEventFilters = (eventFilters: EventFilters) => {
  return Object.entries(eventFilters).map(([event, filters]) => (
    <React.Fragment key={event}>
      <hr style={{ borderColor: '#908E8F', borderWidth: '1px' }} />
      <div
        style={{
          fontSize: '16px',
          color: '#908E8F',
          fontWeight: 700,
          paddingBottom: '10px',
        }}
      >
        {event}
        {Object.entries(filters).map(([field, conditions], index) => (
          <div
            key={field}
            style={{
              fontSize: '14px',
              color: '#908E8F',
              fontWeight: 400,
              marginLeft: '10px',
              marginTop: index === 0 ? '10px' : '0px',
            }}
          >
            {renderFilterValues(field, 'equals', conditions.equals)}
            {renderFilterValues(field, 'starts with', conditions.startsWith)}
          </div>
        ))}
      </div>
    </React.Fragment>
  ));
};

export const EventFiltersModal = ({
  integrationName,
  eventFilters,
  onCancelClicked,
}: {
  integrationName: string;
  eventFilters: EventFilters;
  onCancelClicked: () => void;
}) => {
  return (
    <>
      <Modal isOpen onClose={onCancelClicked}>
        <ModalHeader style={ModalHeaderOverride.style}>
          Event Filters for '{integrationName}'
        </ModalHeader>
        <ModalBody>
          <div style={{ maxHeight: '300px', overflow: 'auto' }}>
            {formatEventFilters(eventFilters)}
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};
